import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";

// Components
import Spinner from "../Components/Spinner";

// Services
import { vehicleService } from "../../Services/vehicle.service"; // eslint-disable-next-line

// Icons
import { IoIosHammer } from "react-icons/io";
import { IoIosBuild } from "react-icons/io";


// Constants
const _pageTitle = "Detalhes de Indicadores";
const _listTitle = "Manutenções";

export default function MaintenanceDetails() {

    const dispatch = useDispatch();
    dispatch({ type: "title", value: _pageTitle });

    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);

    const fetchIndicators = async () => {
        console.log('🐗: fetchIndicators');

        setLoading(true);

        try {

            var result = await vehicleService.fetchVehicleMaintenanceIndicatorDetails();

            console.log("Resultado fetchVehicleMaintenanceIndicatorDetails:");
            console.log(result?.result);

            if (result?.result)
                setData(result?.result);

        } catch (error) {
            console.error(error);
        }
        finally {
            setLoading(false);
        }

    };

    useEffect(() => {
        (async () => {
            await fetchIndicators();
        })();
    }, []);


    return (
        <>
            <div className='container-xxl flex-grow-1 container-p-y'>

                {loading ? <Spinner /> : ""}


                <div style={loading ? { display: "none" } : { display: "" }} className="col-md-6 col-lg-6 order-2 mb-4">
                    <div className="card h-100">
                        <div className="card-header d-flex align-items-center justify-content-between">
                            <h5 className="card-title m-0 me-2"><IoIosHammer size={25} /> {_listTitle}</h5>
                        </div>
                        <div className="card-body">
                            <ul className="p-0 m-0">


                                {data.map((item, index) => (

                                    <li className="d-flex mb-4 pb-1" key={index}>
                                        <div className="avatar flex-shrink-0 me-3">
                                            <IoIosBuild size={23} />
                                        </div>
                                        <div className="d-flex w-100 flex-wrap align-items-center justify-content-between gap-2">
                                            <div className="me-2">
                                                <h6 className="mb-0">{item.licensePlate}</h6>
                                            </div>
                                            <div className="me-2">
                                                <h6 className="mb-0">{item.maintenanceItem}</h6>
                                            </div>
                                            <div className="user-progress d-flex align-items-center gap-1">
                                                {/* <h6 className="mb-0">+82.6</h6>  */}
                                                <span className="text-muted">{item.maintenanceStatus}</span>
                                            </div>
                                        </div>
                                    </li>
                                ))}

                            </ul>
                        </div>
                    </div>
                </div>

            </div>
        </>
    );
};